import avatar from '../assets/images/avatar.png';
import avatar1 from '../assets/images/avatar1.png';
import avatar2 from '../assets/images/avatar2.png';
import avatar3 from '../assets/images/avatar3.png';
import razor from '../assets/images/razor.png';
import logo_rk from '../assets/images/logo-rk.png';
import brush from '../assets/images/brush.png';
import img1 from '../assets/images/grid1.webp';
import img2 from '../assets/images/grid2.jpg';
import img4 from '../assets/images/grid4.webp';
import img5 from '../assets/images/grid5.jpg';
import img6 from '../assets/images/grid6.jpg';
import img7 from '../assets/images/grid7.webp';
import img9 from '../assets/images/grid9.jpg';
import img10 from '../assets/images/grid10.jpg';
import img11 from '../assets/images/grid11.jpg';
import Logo from '../assets/images/logo_white.png';
import img12 from '../assets/images/grid12.jpg';
import tab1 from '../assets/images/tab1.jpg';
import tab2 from '../assets/images/tab2.jpg';
import tab3 from '../assets/images/tab3.jpg';
import men_haircut from '../assets/images/service-men-haircut.png';
import haircut_machine from '../assets/images/service-haircut-machine.png';
import head_shaving from '../assets/images/service-head-shaving.png';
import drawing from '../assets/images/service-drawing.png';
import beard from '../assets/images/service-beard.png';
import beard_painting from '../assets/images/service-beard-painting.png';
import hair_camouflage from '../assets/images/service-hair-camouflage.png';
import beard_camouflage from '../assets/images/service-camouflage-beard.png';
import marker_img from '../assets/images/google-map-logo.png';
import logo_footer from '../assets/images/logo-rk.png';
import logo from '../assets/images/logo.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Logo,
    logo,
    logo_rk,
    avatar,
    avatar1,
    avatar2,
    avatar3,
    razor,
    brush,
    img1,
    img2,
    img4,
    img5,
    img6,
    img7,
    img9,
    img10,
    img11,
    img12,
    tab1,
    tab2,
    tab3,
    men_haircut,
    haircut_machine,
    head_shaving,
    drawing,
    beard,
    beard_painting,
    hair_camouflage,
    beard_camouflage,
    marker_img,
    logo_footer
};
